import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PropertyInformationPopoverValueRow({
  children
}) {
  return /*#__PURE__*/_jsx(Flex, {
    marginInlineStart: "400",
    marginBlockEnd: "100",
    gap: "100",
    flexDirection: "row",
    alignItems: "center",
    blockSize: "24px",
    children: children
  });
}